import { render, staticRenderFns } from "./CalendarManagement.vue?vue&type=template&id=0e827fb3&scoped=true&"
import script from "./CalendarManagement.vue?vue&type=script&lang=js&"
export * from "./CalendarManagement.vue?vue&type=script&lang=js&"
import style0 from "./CalendarManagement.vue?vue&type=style&index=0&id=0e827fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e827fb3",
  null
  
)

component.options.__file = "CalendarManagement.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VParallax } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VApp,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VContainer,
  VDataTable,
  VDatePicker,
  VDialog,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VParallax,
  VSelect,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
